import { withBaseUrl } from "../config/env";

export type ApiOptions = RequestInit & { rawUrl?: boolean };

// Small wrapper around fetch to automatically prefix API base URL and include auth token.
// Usage: apiFetch('/admin/trips', { method: 'GET' })
export const apiFetch = (pathOrUrl: string, options: ApiOptions = {}) => {
  const { rawUrl, ...fetchOptions } = options;
  const url = rawUrl ? pathOrUrl : withBaseUrl(pathOrUrl);

  // Get admin token (fallback to generic token for compatibility)
  const token =
    (typeof localStorage !== "undefined" && localStorage.getItem("adminToken")) ||
    (typeof localStorage !== "undefined" && localStorage.getItem("authToken")) ||
    null;

  // Prepare headers
  const headers = new Headers(fetchOptions.headers);

  // Add Authorization header if token exists
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(url, {
    ...fetchOptions,
    headers,
  });
};

export default apiFetch;
